import { Box, BoxProps } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";

export const SearchIcon = (props: BoxProps) => {
  return <Box as={FiSearch} height="20px" width="20px" {...props} />;
};
